import { useState, useEffect } from "react";
import Taskbar from "../components/Taskbar";
import PastSessions from "../components/PastSessions";
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";

const LiveTv = () => {
  const [mainLoaded, setMainLoaded] = useState(false);
  const [shakeTitle, setShakeTitle] = useState(false);
  const [platform, setPlatform] = useState("facebook"); // Default to YouTube

  const liveVideos = {
    youtube: {
      url: "https://www.youtube.com/embed/N0DrYGCX-R4",
      title: "Welcome To This Live Broadcast",
    },
    facebook: {
      url: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fagmonline%2Fvideos%2F913604574436840%2F&show_text=false&width=560&t=0",
    },
  };

  useEffect(() => {
    const interval = setInterval(() => setShakeTitle(prev => !prev), 30000);
    return () => clearInterval(interval);
  }, []);

  const currentVideo = liveVideos[platform];

  return (
    <>
      <Taskbar />
      <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="bg-bg text-text">
        <div className="max-[942px]:pt-12 min-[942px]:mt-[51px]">
          <div className="flex justify-center gap-6">


            {/* Toggle Buttons */}
            {/* <button
                className={`px-4 py-2 rounded text-text font-medium transition ${
                  platform === "youtube"
                    ? "bg-purple-600 shadow-lg"
                    : "bg-purple-300 hover:bg-purple-400"
                }`}
                onClick={() => { setPlatform("youtube"); setMainLoaded(false); }}
              >
                YouTube Live
              </button>
              <button
                className={`px-4 py-2 rounded text-white font-medium transition ${
                  platform === "facebook"
                    ? "bg-blue-600 shadow-lg"
                    : "bg-blue-300 hover:bg-blue-400"
                }`} */}
            {/* onClick=*/}{() => { setPlatform("facebook"); setMainLoaded(false); }}
            {/* >
                Facebook Live
              </button>  */}
          </div>

          {/* Main Video Display */}
          <div className="w-full max-h-[500px] aspect-video relative overflow-hidden shadow-theme">
            {!mainLoaded && (
              <div className="absolute inset-0 bg-card flex items-center justify-center z-10">
                <div className="w-12 h-12 border-4 border-border border-t-transparent rounded-full  animate-spin"></div>
              </div>
            )}
            <iframe
              className="w-full h-full"
              src={currentVideo.url}
              title={currentVideo.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
              loading="lazy"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              onLoad={() => setMainLoaded(true)}
            ></iframe>
          </div>

          {/* Video Title */}
          <div className={`flex justify-center text-xl font-bold text-secondary text-center ${shakeTitle ? "animate-shake" : ""}`}>
            <span className="mt-4">{currentVideo.title}</span>
          </div>

          {/* Past Sessions */}
          <PastSessions />

          <div className="mt-10 mb-5 text-end font-bold">
            <a className="p-3 rounded bg-accent" href="https://youtube.com/@prophetkevinonline5831?si=lZWJt7vDyBCyZS0C">
              Click Here For More
            </a>
          </div>
        </div>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default LiveTv;
